import { absoluteUrl } from './seo';

/** Dinamik OG görseli (sunucuda og-image.php). */
export function buildOgImageUrl(params: {
  title: string;
  subtitle?: string;
  line1?: string;
  line2?: string;
  line3?: string;
  badge?: string;
}): string {
  const q = new URLSearchParams();
  q.set('title', params.title.slice(0, 120));
  if (params.subtitle) q.set('subtitle', params.subtitle.slice(0, 160));
  if (params.line1) q.set('line1', params.line1.slice(0, 80));
  if (params.line2) q.set('line2', params.line2.slice(0, 80));
  if (params.line3) q.set('line3', params.line3.slice(0, 80));
  if (params.badge) q.set('badge', params.badge.slice(0, 40));
  return absoluteUrl(`/og-image.php?${q.toString()}`);
}
